import { render, staticRenderFns } from "./CreditBar.vue?vue&type=template&id=b3c44218&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./CreditBar.vue?vue&type=script&lang=ts"
export * from "./CreditBar.vue?vue&type=script&lang=ts"
import style0 from "./CreditBar.vue?vue&type=style&index=0&id=b3c44218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c44218",
  null
  
)

export default component.exports